<footer class="footer">
  <div class="footer__inner">
    <p class="footer__copy">&copy; {{ currentYear }} Saarvie. Tous droits réservés.</p>
  </div>
</footer>
